import Chip from "@mui/material/Chip";
import { Stack, Typography } from "@mui/material";
import { CustomCellDate, CrudLink } from "@/shared/components";
import type { ColumnDefinition } from "@/shared/components/CRUD/types";
import type { DataListViewColumns } from "@/shared/components/DataListView";
import type { StreamEntrypointRow } from "./types";

export const getColumnsConfig = (): ColumnDefinition<StreamEntrypointRow>[] => [
  { name: "id", label: "ID", options: { display: false, filter: false } },
  {
    name: "title",
    label: "Название",
    options: {
      customBodyRender: (data: unknown) => {
        const entrypoint = data as StreamEntrypointRow;
        return (
          <CrudLink id={entrypoint.id} tab="details">
            {entrypoint.title}
          </CrudLink>
        );
      },
    },
  },
  {
    name: "platform",
    label: "Платформа",
    options: {
      customBodyRender: (data: unknown) => {
        const platform = data as StreamEntrypointRow["platform"];
        return platform ? platform.title : "—";
      },
    },
  },
  {
    name: "stream",
    label: "Эфир",
    options: {
      sort: false,
      customBodyRender: (data: unknown) => {
        const stream = data as StreamEntrypointRow["stream"];
        return stream ? stream.title : "Свободна";
      },
    },
  },
  {
    name: "liveConnected",
    label: "Онлайн",
    options: {
      sort: false,
      setCellHeaderProps: () => ({ style: { width: 110 } }),
      customBodyRender: (value: unknown) =>
        value ? (
          <Chip label="Онлайн" color="error" size="small" />
        ) : (
          <Chip label="Оффлайн" size="small" variant="outlined" />
        ),
    },
  },
  {
    name: "pull",
    label: "Pull",
    options: {
      sort: false,
      setCellHeaderProps: () => ({ style: { width: 120 } }),
      customBodyRender: (data: unknown) => {
        const pull = data as StreamEntrypointRow["pull"];
        return pull ? pull.status : "—";
      },
    },
  },
  {
    name: "createdAt",
    label: "Создана",
    options: {
      setCellHeaderProps: () => ({ style: { width: 150 } }),
      customBodyRender: (value: unknown) => (
        <CustomCellDate date={value as string} />
      ),
    },
  },
];

export const getTextsConfig = () => ({
  filterTitle: "Фильтры",
  listTitle: "Точки входа",
  refetchList: "Обновить список",
  cancel: "Отмена",
  editItem: "Точка входа",
  showTitle: "Детали",
});

export const getMobileColumnsConfig =
  (): DataListViewColumns<StreamEntrypointRow> => ({
    main: {
      title: "Точка входа",
      sx: { flex: 1, minWidth: 0 },
      renderCell: (row) => (
        <Stack sx={{ minWidth: 0 }}>
          <CrudLink id={row.id} tab="details" noWrap>
            {row.title}
          </CrudLink>
          <Typography variant="body2" color="textSecondary" noWrap>
            {row.platform?.title ?? "—"}
          </Typography>
        </Stack>
      ),
    },
    liveConnected: {
      title: "Онлайн",
      sx: { width: 108, flexShrink: 0 },
      renderCell: (row) =>
        row.liveConnected ? (
          <Chip label="Онлайн" color="error" size="small" />
        ) : (
          <Chip label="Оффлайн" size="small" variant="outlined" />
        ),
    },
  });
